import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import ButtonGray from "components/utils/CustomFields/ButtonGray";
import SkeletonLoading from "components/utils/Loading/SkeletonLoading";

export default function DeleteStockDamageDialog({ open, onClose, onConfirm, loading }) {
  if (!open) return null;

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headInfoSec}>
          <h3>Confirm Delete</h3>
          <CloseIcon className={styles.icon} onClick={loading ? undefined : onClose} />
        </div>

        <div className={styles.contentArea}>
          {loading ? (
            <SkeletonLoading isOpen={true} count={1} height={60} xs={12} />
          ) : (
            <h3 className={styles.subTitle}>
              Deleted Stock Damage records can't be restored, do you want to delete the Stock Damage record?
            </h3>
          )}
        </div>

        <div className={styles.buttonSection}>
          <ButtonGray onClick={onClose} disabled={loading}>
            Cancel
          </ButtonGray>
          <ButtonRed onClick={onConfirm} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </ButtonRed>
        </div>
      </div>
    </div>
  );
}
